import React, { Component } from 'react'
import styles from './map.styl'

export default class MapMarker extends Component {
  render() {
    return (
      <span className={styles.pin} ref="marker">
        <span className={`ico ico--pin ${styles.ico}`} />
      </span>
    )
  }
}
